import { TextInput } from '@msaf/core-react'
import { FilterProps } from '../../utils'

export function FilterText({ value, setValue, labelledBy, onKeyDown }: FilterProps) {
  if (typeof value !== 'string') throw new Error('Invalid value type for `text`')

  return (
    <TextInput id={labelledBy} type='text' value={value} setValue={setValue} onKeyDown={onKeyDown} autoFocus={true} />
  )
}
